import { Guide } from '@/types/guides';

export const extractGuideIdFromSlug = (guideSlug: string): string => {
    return guideSlug.split('-').slice(-5).join('-');
};

export const getGuideUrl = (guide: Guide): { relativePath: string; canonicalSlug: string } => {
    let relativePath: string | undefined;

    const locationSlug = guide.locations?.[0]?.slug || 'local';
    const canonicalUrl = guide.urls.find((url) => url.type === 'canonical');

    const canonicalSlug =
        canonicalUrl?.url.split('/').pop() || formatGuideSlug(guide.name, guide.guideId);

    if (canonicalUrl) {
        try {
            const urlObj = new URL(canonicalUrl.url);
            relativePath = urlObj.pathname;
        } catch (e) {
            relativePath = `/it-lists/${locationSlug}/${canonicalSlug}`;
            console.error(`Error parsing canonical guide URL ${canonicalUrl.url}:`, e);
        }
    } else {
        relativePath = `/it-lists/${locationSlug}/${canonicalSlug}/`;
    }

    // Ensure relativePath ends with a '/' to avoid redirects
    if (!relativePath.endsWith('/')) {
        relativePath += '/';
    }

    return { relativePath, canonicalSlug };
};

// This logic is copied from guides-service
// https://github.com/eventbrite/guides-service/blob/e822607f9fddd4b81b35bf6b394754c491039c60/service/src/command-handlers/GuideCommands/GuideCreateCommandHandler.ts#L29
const formatGuideSlug = (guideName: string, guideId: string): string => {
    const normalizedName = guideName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '-')
        .substring(0, 50);
    const guideNameSlug = `${normalizedName}-${guideId.toLowerCase()}`;
    return guideNameSlug;
};
